import { render, staticRenderFns } from "./SkeletonCard.vue?vue&type=template&id=5a647e52&scoped=true"
import script from "./SkeletonCard.vue?vue&type=script&lang=ts"
export * from "./SkeletonCard.vue?vue&type=script&lang=ts"
import style0 from "./SkeletonCard.vue?vue&type=style&index=0&id=5a647e52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a647e52",
  null
  
)

export default component.exports